// Returns a string containing a comma-separated list of window features given with their corresponding values in the form "name=value".
//   Used for https://developer.mozilla.org/en-US/docs/Web/API/Window/open `windowFeatures`
export function toCommaSeparatedListString(
  options: Record<string, string | number | boolean>
) {
  return Object.entries(options).reduce((listString, [key, value], i) => {
    return `${listString}${i === 0 ? '' : ','}${key.toLowerCase()}=${value}`;
  }, '');
}
